import React from "react";
import { PageBanner, SectionTitle, EnquiryForm } from "../components/Shared";
import { ADMISSION_STEPS, DOCUMENTS_REQUIRED } from "../data/siteData";
import "./InnerPages.css";

const AdmissionsPage = () => {
  return (
    <>
      <PageBanner title="Admissions 2026-27" breadcrumb="Admissions" />

      {/* Steps */}
      <section className="section section--bg">
        <div className="container">
          <SectionTitle
            title="Admission Process"
            subtitle="Simple steps to enrol your child at IDPS Mahore"
          />
          <div className="grid-4">
            {ADMISSION_STEPS.map((s) => (
              <div key={s.n} className="step-card card">
                <div className="step-card__num">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Guidelines */}
      <section className="section">
        <div className="container">
          <SectionTitle title="Admission Guidelines" />
          <div className="inner-content-box">
            <p className="inner-para">
              IDPS Mahore welcomes applications for admission to all classes from
              Pre-Nursery to Grade VIII. The school follows the CBSE curriculum
              and the medium of instruction is English.
            </p>
            <h3 className="inner-subheading">Documents Required</h3>
            <ul className="arrow-list">
              {DOCUMENTS_REQUIRED.map((d) => (
                <li key={d}>
                  <span className="arrow-list__icon">▸</span> {d}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Enquiry Form */}
      <section className="section section--bg">
        <div className="container">
          <SectionTitle title="Enquire Online" />
          <EnquiryForm />
        </div>
      </section>
    </>
  );
};

export default AdmissionsPage;
